// src/public/rsvp/parts/FooterBar.jsx
import React from 'react';
import { alpha } from '@mui/material/styles';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

export function FooterBar() {
  return (
    <MDBox
      mt={0.75} // ❌ 2 yerine daha sıkı
      pt={0.75}
      sx={(t) => ({
        display: 'flex',
        alignItems: { xs: 'flex-start', sm: 'center' },
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 0.75,
        borderTop: `1px solid ${
          t.palette.mode === 'dark'
            ? alpha(t.palette.common.white, 0.1)
            : alpha(t.palette.common.black, 0.08)
        }`,
      })}
    >
      <MDTypography variant="caption" sx={{ opacity: 0.7, fontWeight: 700 }}>
        © {new Date().getFullYear()} Solisup
      </MDTypography>
      <MDTypography variant="caption" sx={{ opacity: 0.7 }}>
        Link kişiye özeldir.
      </MDTypography>
    </MDBox>
  );
}
